/*
 * Ryan O'Dowd
 * 2025-07-08
 * © Copyright 2025 Oakwood Software Consulting, Inc.  All Rights Reserved.
 */
import PricingColumn from './PricingColumn';
import React from 'react';
import {
  View,
} from 'react-native';
import getStyles from './styles';
import hooks from '@hooks';

const PricingMatrix = () => {
  const styles = hooks.useStyles(getStyles);

  return (
    <View style={styles.container}>
      <PricingColumn
        title='Wrinkly apps'
        cost='$0 - free for everyone'
        features={[
          'Free to use',
          'Account syncing between all platforms (iOS, Android, web)',
          'Access to all supported Bible translations', // @TODO: link to supported versions
          'Read, play games, and complete tests',
          'Discover reading plans, memory goals, and more',
        ]}
      />

      <PricingColumn
        title='Classroom LMS'
        cost='$10/user/year'
        hasBuyButton={true}
        features={[
          'Access to separate teacher portal',
          'Manage classrooms',
          'Assign lessons',
          'Upload custom curriculum',
          'Track student progress',
          'Export reports for parents',
        ]}
      />

      <PricingColumn
        title='Fundraising'
        cost='Contact us for rates'
        hasInfoButton={true}
        features={[
          'Sponsors donate per verse memorized',
          'Track participant progress',
          'Manage donor pledges',
          'Wrinkly handles all payment information',
        ]}
      />
    </View>
  );
};

export default PricingMatrix;
